<template>
  <div>
    <vx-breadcrumb :list="breadcrumbList" class="custom-bread-crumb" />
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <div @click="cancelEdit" class="vx-row cursor-pointer">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("customers.label.edit_ticket") }}</h4>
          </div>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <form>
          <div class="vx-row">
            <div class="vx-col w-2/3">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.category')"
                    >
                      <v-select
                        label="mCodeValue"
                        :options="ticketTemplates.problemsDatas"
                        :placeholder="$t('customers.label.SelectCategory')"
                        :reduce="(mCodeValue) => mCodeValue.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.problemCode"
                        @input="getSubCategory"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.mCodeValue
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.sub_category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.sub_category')"
                    >
                      <v-select
                        label="subCategory"
                        :options="subCategoryItem"
                        :placeholder="$t('customers.label.SelectSubCategory')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.subCategory"
                        :reduce="(subCategory) => subCategory.subCategory"
                        @input="setPriority"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="pb-5">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.priority')"
                    >
                      <vs-input
                        :label="$t('customers.label.priority')"
                        v-model="ticket.priority"
                        class="w-full font-semibold mb-2 starlabel"
                        icon-no-border
                        :danger="false"
                        danger-text="wrong input"
                        disabled="true"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full pb-5">
                  <vs-input
                    :label="$t('customers.label.ticket_date')"
                    class="w-full font-semibold starlabel"
                    readonly
                    v-model="ticket.ticketDate"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.source")
                    }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.sourceData"
                      :placeholder="$t('customers.label.SelectSource')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      v-model="ticket.sourceOfTicket"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.due_time")
                    }}</small>
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full"
                      disabled
                      v-model="ticket.dueTime"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.teamCode"
                        @input="getUserByTeam"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team_user")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team user"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.assignedTo"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("Reference")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="reference"
                      :key="resetKey"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.reference"
                        @input="onChangeReference"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("Reference Id")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="reference id"
                      :key="resetKey"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.referenceId"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
                <div class="vx-col sm:w-full">
                  <div class="vx-row">
                    <div class="vx-col sm:w-full lg:full md:full pt-1 px-6">
                      <MultiFileUploader
                        @filesUpdate="changeFile"
                        @downloadDocument="downloadDocument"
                        :existingFiles="existingFiles"
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-full md:w-full mt-4">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.comment")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.comment')"
                    >
                      <vs-textarea
                        class="w-full"
                        v-model="ticket.comment"
                        rows="4"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div style="height: 30px"></div>
                <div class="center mx-auto">
                  <span class="ml-1 mr-1">
                    <vs-button
                      type="border"
                      class="footerButton-next"
                      style="top: 0px"
                      @click="cancelEdit"
                      >{{ $t("Cancel") }}</vs-button
                    >
                  </span>
                  <span class="ml-1 mr-1">
                    <vs-button
                      @click="updateTicket"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("customers.label.submit") }}</vs-button
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/3">
              <div class="view-container">
                <div class="pb-2 font-semibold flex justify-between">
                  <span> {{ $t("customers.label.TicketHistory") }}</span>
                  <feather-icon
                    v-if="
                      ticketById.attachments &&
                      ticketById.attachments[0].fileName &&
                      ticketById.attachments[0].fileName !== 'null'
                    "
                    title="Download Uploaded File"
                    icon="DownloadIcon"
                    @click.stop="downloadFile(ticketById.id)"
                    class="icon_row mr-1 text-success ml-auto"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </div>
                <div
                  class="text-sm ticket-el"
                  v-if="ticketDetailsById && ticketDetailsById.id"
                >
                  <vx-card
                    class="mt-3 mb-3 history-card"
                    :class="getCardStatusClass(ticketDetailsById.status)"
                  >
                    <div class="vx-row w-full detail-text">
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.id") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.id }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.user") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.createdByUsername }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_date") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ getDate2(ticketDetailsById.strTicketDate) }}
                      </div>
                      <div
                        v-if="ticketDetailsById.strTicketDate"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{ $t("customers.label.created_time") }}</b>
                      </div>
                      <div
                        v-if="ticketDetailsById.strTicketDate"
                        class="vx-col md:w-1/2"
                      >
                        {{ getTime(ticketDetailsById.strTicketDate) }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("SLA Time") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.etaResponse }}
                      </div>
                      <div class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.description") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ ticketDetailsById.description }}
                      </div>
                    </div>
                  </vx-card>
                </div>
                <div
                  class="text-sm ticket-el"
                  v-for="(item, index) in ticketViewById"
                  :key="index"
                >
                  <vx-card
                    class="mt-3 mb-3 history-card"
                    :class="getCardStatusClass(item.status)"
                  >
                    <div class="vx-row w-full detail-text">
                      <div v-if="item.assignedTo" class="vx-col md:w-1/2">
                        <b>{{ $t("leads.label.assigned_to") }}</b>
                      </div>
                      <div v-if="item.assignedTo" class="vx-col md:w-1/2">
                        {{ item.assignedTo }}
                      </div>

                      <div
                        v-if="item.strTicketDate && item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{ $t("customers.label.resolution_date") }}</b>
                      </div>
                      <div v-else class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_date") }}</b>
                      </div>
                      <div class="vx-col md:w-1/2">
                        {{ getDate2(item.strTicketDate) }}
                      </div>

                      <div v-if="item.strTicketDate" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.created_time") }}</b>
                      </div>
                      <div v-if="item.strTicketDate" class="vx-col md:w-1/2">
                        {{ getTime(item.strTicketDate) }}
                      </div>
                      <div v-if="item.status" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.status") }}</b>
                      </div>
                      <div v-if="item.status" class="vx-col md:w-1/2">
                        {{ item.status }}
                      </div>
                      <div v-if="item.lastComment" class="vx-col md:w-1/2">
                        <b>{{ $t("customers.label.last_comment") }}</b>
                      </div>
                      <div v-if="item.lastComment" class="vx-col md:w-1/2">
                        {{ item.lastComment }}
                      </div>

                      <div
                        v-if="item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        <b>{{
                          $t("customers.label.resolution_description")
                        }}</b>
                      </div>
                      <div
                        v-if="item.resolutionDescription"
                        class="vx-col md:w-1/2"
                      >
                        {{ item.resolutionDescription }}
                      </div>

                      <!-- <div class="vx-col md:w-1/2">
                        <br />
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <b>{{
                              $t("customers.label.problem_description")
                            }}</b>
                            <div class="vx-col">
                              {{ item.problemDescription }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2">
                        <br />
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <b>{{ $t("customers.label.last_comment") }}</b>
                            <div class="vx-col">{{ item.lastComment }}</div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { BUCKET_BASE_URL } from "@/http/index";
import MultiFileUploader from "@/components/UploadMultipleFile.vue";
import { setHeader, removeHeader } from "@/http";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  // reference: null,
  // referenceId: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  comment: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: moment().format("HH:mm:ss A"),
};

export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        {
          name: "Edit Ticket",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      ticket: { ...ticketObj },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d m Y H:i:S",
      },
      bulkUploads: {
        files: null,
      },
      categoryId: null,
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    MultiFileUploader,
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      ticketById: (state) => state.customerTicket.ticketById, // Need to remove
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      teamUsers: (state) => state.customer.teamUsers,
      ticketViewById: (state) => state.customerTicket.ticketViewById,
      ticketDocumentData: (state) => state.customerTicket.ticketDocumentData,
      ticketDetailsById: (state) => state.customerTicket.ticketDetailsById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    existingFiles() {
      if (this.ticketDocumentData) {
        const file = this.ticketDocumentData;
        return file ? file : "";
      }
    },
  },
  methods: {
    async changeFile(file) {
      this.bulkUploads.files = file;
    },
    getTime(time) {
      return time.split(" ")[1];
    },
    async enhanceTicketDocumentsWithImageUrls() {
      if (
        !Array.isArray(this.ticketDocumentData) ||
        !this.ticketDocumentData.length
      )
        return;

      for (const doc of this.ticketDocumentData) {
        if (doc.type.startsWith("image/")) {
          try {
            const response = await this.$store.dispatch(
              "customerTicket/getUploadedDocumentDataAction",
              {
                ticketId: this.$route.params.ticketId,
                docId: doc.id,
                showImages: true,
              }
            );

            if (response && response.data && response.data.base64Data) {
              this.$set(
                doc,
                "imageUrl",
                `data:image/png;base64,${response.data.base64Data}`
              );
            } else {
              this.$set(doc, "imageUrl", null);
            }
          } catch (error) {
            console.error(`Failed to fetch image for docId ${doc.id}:`, error);
            this.$set(doc, "imageUrl", null);
          }
        }
      }
    },
    downloadFile(ticketId) {
      window.open(BUCKET_BASE_URL + `/tickets/${ticketId}/print`);
    },
    async downloadDocument(fileName, docId) {
      const ticketId = this.$route.params.ticketId;
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(
          `${BUCKET_BASE_URL}/customerticket/${ticketId}/documents/${docId}/attachment`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "ngb-platform-tenantid": "default",
            },
          }
        );
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    async getUserByTeam() {
      this.ticket.assignedTo = null;
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async onChangeReference() {
      this.ticket.referenceId = null;
      try {
        // this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTicketTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancelEdit() {
      if (this.$route.query.type == "customer") {
        this.$router.push("/customer_tickets");
      } else if (this.$route.query.type == "entity") {
        this.$router.push("/entity_tickets");
      } else {
        this.$router.push({
          path: `/customers/view_customer/${this.$route.params.id}`,
          query: { activePage: 5 },
        });
      }
    },
    async updateTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        type: "Customer",
        problemCode: this.ticket.problemCode,
        category: this.ticket.problemCode,
        subCategory: this.ticket.subCategory,
        ticketDate: this.ticket.ticketDate,
        priority: this.ticket.priority,
        sourceOfTicket: this.ticket.sourceOfTicket,
        dueTime: this.ticket.dueTime,
        description: this.ticket.description,
        comments: this.ticket.comment,
        assignedTo: this.ticket.assignedTo,
        teamId: this.ticket.teamCode,
        teamUserId: this.ticket.assignedTo,
        locale: "en",
        dateFormat: "dd MMMM yyyy HH:mm:ss",
      };
      try {
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        if (this.bulkUploads.files && this.bulkUploads.files.length > 0) {
          formData.append("name", "attachment");
          this.bulkUploads.files.forEach((file) => {
            formData.append("file", file);
          });
        }
        formData.append("ticketData", JSON.stringify(payload));
        removeHeader("Content-Type");

        const data = {
          id: this.$route.params.ticketId,
          data: formData,
        };
        await this.$store.dispatch("customer/updateTicket", data);

        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Updated Successfully!",
          type: "success",
        });
        this.cancelEdit();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    setPriority(selectedSubCategory) {
      const subCategoryObj = this.subCategoryItem.find(
        (item) => item.subCategory === selectedSubCategory
      );
      this.ticket.priority = subCategoryObj.priority;
    },
    async getSubCategory(categoryId) {
      this.ticket.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.ticket.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    dateFormat(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getDate2(date) {
      const d = moment(date, "DD-MM-YYYY");
      const formattedDate = d.format(this.formattedDate);
      return formattedDate;
    },
    timeFormat(date) {
      return moment(date).format("HH:mm:ss");
    },
    async getTicketById() {
      try {
        this.$store.dispatch(
          "customerTicket/setsTicketById",
          this.$route.params.ticketId
        );
        await this.$store.dispatch(
          "customerTicket/getTicketDetailsByIdAction",
          {
            id: this.$route.params.ticketId,
          }
        );

        await this.getSubCategory(this.ticketDetailsById.problemCode);

        const TicketDate = moment(
          this.ticketDetailsById.strTicketDate,
          "DD-MM-YYYY HH:mm:ss"
        ).format("DD MM YYYY HH:mm:ss");

        this.ticket.assignedTo = this.ticketDetailsById.teamUserId;
        this.ticket.priority = this.ticketDetailsById.priority;
        this.ticket.problemCode = this.ticketDetailsById.problemCode;
        this.ticket.subCategory = this.ticketDetailsById.subCategorys;
        this.ticket.ticketDate = TicketDate;
        this.ticket.status = this.ticketDetailsById.status;
        this.ticket.dueTime = this.ticketDetailsById.strDueDate;
        this.ticket.description = this.ticketDetailsById.description;
        this.ticket.sourceOfTicket = this.ticketDetailsById.sourceOfTicket;
        this.ticket.teamCode = Number(this.ticketDetailsById.teamCode);

        await this.$store.dispatch(
          "customer/getUserByTeam",
          this.ticket.teamCode
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTicketDocumentMethod() {
      try {
        await this.$store.dispatch(
          "customerTicket/getTicketDocumentAction",
          this.$route.params.ticketId
        );
        await this.enhanceTicketDocumentsWithImageUrls();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "text-blue";
        case "REOPEN":
          return "text-yellow";
        case "CLOSED":
          return "text-green";
        case "Escalated":
          return "text-red";
        default:
          return "text-gray";
      }
    },
    getCardStatusClass(status) {
      switch (status) {
        case "OPEN":
          return "border-blue";
        case "REOPEN":
          return "border-yellow";
        case "CLOSED":
          return "border-green";
        case "Escalated":
          return "border-red";
        default:
          return "border-gray";
      }
    },
    getPriorityClass(priority) {
      switch (priority) {
        case "HIGH":
          return "high-priority";
        case "MEDIUM":
          return "medium-priority";
        case "LOW":
          return "low-priority";
        default:
          return "";
      }
    },
  },
  watch: {},
  async mounted() {
    await this.getTicketTemplate();
    await this.getTicketById();
    await this.getTicketDocumentMethod();
  },
};
</script>

<style scoped>
.flatpickr-calendar.open {
  z-index: 999999999999;
}
.ticket-el {
  border-top: 1px solid #ccc;
}
.view-container {
  background: #eee;
  height: 24rem;
  overflow-y: scroll;
  padding: 10px;
  border-radius: 8px;
}
.high-priority {
  color: red;
}

.medium-priority {
  color: orange;
}

.low-priority {
  color: green;
}
.text-blue {
  color: blue;
}
.text-yellow {
  color: rgb(224, 224, 27);
}
.text-red {
  color: red;
}
.text-green {
  color: green;
}
.text-gray {
  color: gray;
}
.border-blue {
  border: 2px solid blue;
  background-color: rgb(180, 180, 255);
}
.border-yellow {
  border: 2px solid rgb(224, 224, 27);
  background-color: rgb(255, 255, 200);
}
.border-red {
  border: 2px solid red;
  background-color: rgb(255, 177, 177);
}
.border-green {
  border: 2px solid green;
  background-color: rgb(200, 255, 200);
}
.border-gray {
  border: 2px solid gray;
}
.history-card ::v-deep .vx-card__body {
  padding: 12px !important;
}
</style>
